import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import { Helmet } from 'react-helmet';

const Live = ({ url }) => {
  return (
    <>
      <Helmet>
        <title>PL by Edves | Live</title>
      </Helmet>
      <DashboardHeader />
      <div>
        <iframe
          src={url}
          frameborder='0'
          style={{
            overflow: 'hidden',
            overflowX: 'hidden',
            height: '90%',
            width: '100%',
            position: 'absolute',
            top: '80px',
            left: '0px',
            right: '0px',
            bottom: '0px',
          }}
          width='100%'
        ></iframe>
      </div>
    </>
  );
};

export default Live;
